
export const VERSION = '5.4.37'; // Update this manually on each release


